import type { CalEvent, Template } from '../shared/types';
import { addDays, diffDays, todayISO } from './dates';

export interface DueInfo {
  template: Template;
  dueDate: string;
  daysUntil: number; // negativ = überfällig
  lastDate: string | null;
}

/**
 * Berechnet für jeden Auswahltermin, wann er als Nächstes fällig ist:
 * fällig = Datum des letzten (oder zuletzt geplanten) Termins + Frequenz in Wochen.
 * Noch nie eingetragene Termine gelten als heute fällig.
 * Sortiert: dringendster Termin zuerst.
 */
export function computeDue(templates: Template[], events: CalEvent[], today: string = todayISO()): DueInfo[] {
  const result = templates.map((template): DueInfo => {
    const name = template.name.trim().toLowerCase();
    let last: string | null = null;
    for (const e of events) {
      if (e.templateId === template.id || e.title.trim().toLowerCase() === name) {
        if (last === null || e.date > last) last = e.date;
      }
    }
    const dueDate = last ? addDays(last, template.weeks * 7) : today;
    return { template, dueDate, daysUntil: diffDays(today, dueDate), lastDate: last };
  });
  result.sort((a, b) => a.daysUntil - b.daysUntil || a.template.name.localeCompare(b.template.name, 'de'));
  return result;
}

export function dueHint(info: DueInfo): string {
  if (info.lastDate === null) return 'noch nie eingetragen';
  const d = info.daysUntil;
  if (d < 0) return d === -1 ? '1 Tag überfällig' : `${-d} Tage überfällig`;
  if (d === 0) return 'heute fällig';
  return d === 1 ? 'fällig morgen' : `fällig in ${d} Tagen`;
}
